var SCROLL_THRESHOLDS = [25, 50, 75, 100];

document.addEventListener("click", e => {
  Shopify.analytics.publish("click", {
    event: "custom_click",
    event_source: "custom_pixel",
    elementClasses: e.target.classList?.value || "",
    elementId: e.target.id || "",
    elementText: e.target.innerText?.replaceAll("\n", " ") || "",
    elementTarget: e.target?.target || "",
    elementUrl: e.target.href || e.target?.href || ""
  });
});

const thresholds = SCROLL_THRESHOLDS,
      triggeredThresholds = new Set();

function debounce(e, t) {
  let l;
  return function (...r) {
    clearTimeout(l);
    l = setTimeout(() => e.apply(this, r), t);
  };
}

function checkScrollThresholds() {
  let e = window.scrollY || document.documentElement.scrollTop,
      t = document.documentElement.scrollHeight,
      l = document.documentElement.clientHeight,
      r = Math.round(e / (t - l) * 100);
  
  thresholds.forEach(e => {
    if (r >= e && !triggeredThresholds.has(e)) {
      Shopify.analytics.publish("scroll_depth", {
        event: "custom_scroll",
        event_source: "custom_pixel",
        scrollThreshold: e,
        scrollUnits: "percent",
        scrollDirection: "vertical"
      });
      triggeredThresholds.add(e);
    }
  });
}

window.addEventListener("scroll", debounce(checkScrollThresholds, 100));
